import { Fieldset } from "primereact/fieldset";
import { FieldSetTypes } from "types/v1/main/structure/fieldSetTypes";

const FieldSet = (props: FieldSetTypes) => {

    let classes = props.className;
    if (props.scrollable) {
        classes += " p-fieldset-scroll";
    }

    return (
        <>
            { props.required &&
                <p className="text-red text-bold instructions mb-1">* required entry</p>
            }
            <Fieldset
                className={classes}
                legend={props.legend}
                toggleable={props.toggleable}
                collapsed={props.collapsed}
            >
                {props.children}
            </Fieldset>
        </>
    )
}

export default FieldSet;

